export default __webpack_public_path__ + "static/media/pensée.77d2680c.svg";